import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import apiClient from '../api/client';

export function useAuth() {
  const user           = useAuthStore((s) => s.user);
  const accessToken    = useAuthStore((s) => s.accessToken);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const setAuth        = useAuthStore((s) => s.setAuth);
  const clearAuth      = useAuthStore((s) => s.clearAuth);
  const updateUser     = useAuthStore((s) => s.updateUser);
  const navigate = useNavigate();

  const logout = useCallback(async () => {
    try {
      await apiClient.post('/auth/logout');
    } catch {
      // Swallow error — we still want to clear local state
    } finally {
      clearAuth();
      navigate('/login', { replace: true });
    }
  }, [clearAuth, navigate]);

  const refreshProfile = useCallback(async () => {
    try {
      const response = await apiClient.get<{
        data: import('@repo/types').AuthUser;
      }>('/auth/me');
      updateUser(response.data.data);
    } catch {
      // Ignore — auth interceptor handles token issues
    }
  }, [updateUser]);

  return {
    user,
    accessToken,
    isAuthenticated,
    setAuth,
    clearAuth,
    logout,
    refreshProfile,
  };
}
